import { getAvatarPath } from "@/utils/avatar-helper";
import { chessPieceSvg } from "@/utils/chess-svg-helper";
import GameHelper from "@/utils/game-helper";
import {
  distanceFromNow,
  distanceToNow,
  formatDate,
  humanizeDuration,
} from "@shared/utils/date-helper";
import Vue from "vue";

Vue.filter("asDayjsFormat", (d, format) => {
  if (!d) return "";
  return formatDate(d, format);
});

Vue.filter("asDate", (d) => {
  if (!d) return "";
  return formatDate(d, "DD MMM YYYY");
});

Vue.filter("asTime", (d) => {
  if (!d) return "";
  return formatDate(d, "hh:mm A");
});

Vue.filter("asDateTime", (d, format) => {
  if (!d) return "";
  return formatDate(d, format ? format : "DD MMM YYYY hh:mm A");
});

Vue.filter("humanizeSeconds", (seconds, suffix = true) => {
  return humanizeDuration(seconds, "second", suffix);
});

Vue.filter("asAvatar", (dna) => getAvatarPath(dna));

Vue.filter("asMmSs", (timeLeft) => {
  if (timeLeft < 0) timeLeft = 0;
  let minutes = Math.floor(timeLeft / 60);
  let hours = Math.floor(minutes / 60);
  let seconds = Math.floor(timeLeft % 60);

  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (hours > 0) {
    minutes = Math.floor(minutes % 60);
    return `${hours}:${minutes}:${seconds}`;
  } else {
    return `${minutes}:${seconds}`;
  }
});

Vue.filter("asMmSsFloat", (timeLeft) => {
  if (timeLeft < 0) timeLeft = 0;
  const minutes = Math.floor(timeLeft / 60);
  let seconds = (timeLeft % 60).toFixed(3);
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${minutes}:${seconds}`;
});

Vue.filter("distanceToNow", (date) => {
  if (!date) return "";
  return distanceToNow(date);
});

Vue.filter("distanceFromNow", (date) => {
  if (!date) return "";
  return distanceFromNow(date);
});

Vue.filter("chessPieceSvg", (piece_color) => {
  return chessPieceSvg(piece_color);
});

Vue.filter("matchResultText", function (result, whiteScore, blackScore) {
  return GameHelper.resultText(whiteScore, blackScore, result);
});

Vue.filter("timeText", function (value) {
  return `${value.baseTimeControl}+${value.increment ? value.increment : 0}`;
});

// Formats a FEN string by adding zero-width spaces after slashes for better line wrapping
Vue.filter("wrappableFen", function (fenString) {
  if (!fenString) return "";
  return fenString.replace(/\//g, "/\u200b");
});

// Formats chess evaluation scores (handles both regular scores and mate scores)
Vue.filter("asChessEvalScore", function (score, mateValue) {
  if (mateValue !== null && mateValue !== undefined) {
    return `#${mateValue}`;
  }
  if (score === null || score === undefined) return "";
  return (score / 100).toFixed(1);
});
